import { FormControl, MenuItem, Select, SelectChangeEvent } from "@mui/material";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { OrganizationContent } from "../components";
import { DivDocument } from "./style";

export default function OrganizationContract() {
	const { t } = useTranslation();
	const [contract, setContract] = useState("0");
	const handleContractChange = (e: SelectChangeEvent) => {
		setContract(String(e.target.value));
	};
	return (
		<OrganizationContent title={t("standard_contract.title")}>
			<FormControl style={{ width: "280px" }}>
				<Select value={contract} onChange={handleContractChange}>
					<MenuItem value={0}>{t("standard_contract.foodlens")}</MenuItem>
					<MenuItem value={1}>{t("standard_contract.caloai")}</MenuItem>
				</Select>
			</FormControl>
			<DivDocument style={{ marginTop: "1.5rem" }}>
				{contract === "0" ? (
					<iframe
						title="contract"
						style={{ width: "100%", height: "150vh" }}
						src="https://program-contents-images.s3.ap-northeast-2.amazonaws.com/FoodLens_Solution_Contract.pdf"
					/>
				) : (
					<>
						<iframe
							title="contract"
							style={{ width: "100%", height: "150vh" }}
							src="/contract/CaloAI_20230804.pdf"
						/>
					</>
				)}
			</DivDocument>
		</OrganizationContent>
	);
}
